import { Form, Input } from 'antd'
import React, { useMemo } from 'react'
import { profileScreen } from '../../../../translates'
import { validateTitleRus } from '../../../../helper'
import SberIcon from '../../SberIcon'
import TinkoffIcon from '../../TinkoffIcon'

const HouseFormItem = ({
  label = profileScreen.input.registrationAddresshouse.label,
  rules = undefined,
  requiredRule = false,
  messageRule = profileScreen.input.registrationAddresshouse.message,
  size = 'large',
  placeholder = profileScreen.input.registrationAddresshouse.placeholder,
  showSberIcon = false,
  showTinkoffIcon = false
}) => {
  const labelParam = useMemo(() => {
    return showSberIcon || showTinkoffIcon
      ? (
        <>
          {label}
          {showSberIcon && <SberIcon style={{ marginLeft: '0.5rem' }} />}
          {showTinkoffIcon && <TinkoffIcon style={{ marginLeft: '0.5rem' }} />}
        </>
      )
      : label
  }, [label, showSberIcon, showTinkoffIcon])

  return (
    <Form.Item
      name={['personalData', 'registrationAddress', profileScreen.input.registrationAddresshouse.name]}
      label={labelParam}
      rules={rules ?? [{ required: requiredRule, message: messageRule, validator: validateTitleRus }]}
    >
      <Input
        size={size}
        placeholder={placeholder}
      />
    </Form.Item>
  )
}
export default HouseFormItem
